import { render, staticRenderFns } from "./DesignPreview.vue?vue&type=template&id=2cd5821c&scoped=true"
import script from "./DesignPreview.vue?vue&type=script&lang=js"
export * from "./DesignPreview.vue?vue&type=script&lang=js"
import style0 from "./DesignPreview.vue?vue&type=style&index=0&id=2cd5821c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd5821c",
  null
  
)

export default component.exports